<template>
	<div>
		<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
			<div v-if="data" class="modal-dialog modal-lg" role="document">
				<div v-if="data" class="modal-content">
					<div class="modal-header">
						<div class="btn-toolbar pull-right" role="toolbar">
							<div class="btn-group" role="group" aria-label="...">
								<button type="button" class="close" @click="close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
						</div>
						<h4  class="modal-title">Extras</h4>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-md-12">
								<div class="btn-toolbar pull-right" role="toolbar">
									<div class="btn-group" role="group" aria-label="...">
										<button @click="$refs.create.open" type="button" class="btn btn-success btn-circle">
											<i aria-hidden="true" class="fa fa-plus"></i>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="data.extras" class="modal-body">
						<div v-if="data.extras.length" class="row">
							<div class="col-md-12">
								<table class="table table-condensed table-hover">
									<thead>
										<tr>
											<th>NOMBRE</th>
											<th>VALOR VENTA</th>
											<th>VALOR COMPRA</th>
											<th>DESCRIPCIÓN</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="extra in data.extras">
											<td>
												{{ extra.name }}
											</td>

											<td>
												{{ extra.sale_value }}
											</td>

											<td>
												{{ extra.purchase_value }}
											</td>

											<td>
												<div v-html="extra.description"></div>
											</td>

											<td>
												<div role="toolbar" class="btn-toolbar pull-right">
													<div role="group" aria-label="..." class="btn-group">
														<button @click="$refs.edit.open(extra)" type="button" title="Editar" class="btn btn-info btn-circle">
															<i class="fa fa-pencil-square-o" aria-hidden="true"></i>
														</button>
													</div>
													<div role="group" aria-label="..." class="btn-group">
														<button @click="destroy(extra)" type="button" title="Eliminar" class="btn btn-danger btn-circle">
															<i aria-hidden="true" class="fa fa-trash"></i>
														</button>
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" @click="close">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
		
		<create
			ref="create"
			@updated="$emit('updatedExtra')"
			:user="user"
			:isAuth="isAuth"
			:data="data"
			:type="type">
		</create>

		<edit
			ref="edit"
			@updated="$emit('updatedExtra')"
			:user="user"
			:isAuth="isAuth"
			:data="data"
			:type="type">
		</edit>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Create from './../views/Create'
	import Edit from './../views/Edit'

	export default {
		props: ['user', 'isAuth', 'type'],
		components: {
			'create': Create,
			'edit': Edit,
		},
		data () {
			return {
				modal: {
					selector: 'modal-product-extras',
				},

				data: null,
			}
		},
		methods: {
			open(data) {
				if(data) {
					this.data = data
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			destroy(extra) {
				var that = this
				var api = null
				if(this.type == 'product') {
					api = 'admin/management/products/extras/' + extra.id
				} else {
					if(this.type == 'productStorage') {
						api = 'admin/management/products/storages/extras/' + extra.id
					}
				}
				if(api) {
					swal.queue([{
						title: that.$t("messages.attention"),
						text: that.$t("messages.item_can_not_be_retrieved"),
						type: "warning",
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showCancelButton: true,
						showLoaderOnConfirm: true,
						preConfirm: function () {
							return new Promise(function (resolve) {
								that.$http.delete(api)
								.then(response => {
									let index = that.data.extras.indexOf(extra)
									that.data.extras.splice(index, 1)
									swal(response.body.title, response.body.text, response.body.type)
									that.$emit('updatedExtra')
								}).catch(function(response) {
									console.log(response)
								})
							})
						}
					}]).catch(swal.noop)
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/extras/layout/Extras.vue